<template>
  <section>
    <!-- Header -->
    <left-menu/>

    <button-back :btnRoute="'/'"/>

    <div id="mainContent" class="history-point">
      <div class="row">

        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">{{pgTitle}}</h1>
<!--          <i v-on:click="forceReload()" v-tooltip.top-center="'A última atualização dos dados foi feita no dia ' + this.lastAtt + '. Para atualizar novamente, clique aqui.'" class="fa fa-info-circle info-help" aria-hidden="true"></i>-->
        </div>

        <div v-if="showDtChange && loadingRequest" class="col-xs-12 col-sm-12 col-md-12 day-and-info offset-top-30">
          <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 37px; display: inline-block; width: 12%;'"/>
          <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 18px; width: 14%; position:absolute;right:0;top:20px;'"/>
        </div>
        <div v-if="showDtChange && !loadingRequest && listPoint.length" class="col-xs-12 col-sm-12 col-md-12 day-and-info offset-top-30">
          <p v-if="listPoint.length === 1" class="nunito txt-info">Mostrando o dia atual</p>
          <p v-if="listPoint.length > 1" class="nunito txt-info">Mostrando os últimos {{listPoint.length}} dias</p>

          <div class="date-change date-change-history">
            <p v-on:click="openCalendar()" v-if="!selectedDate" class="nunito text date-history-point">
              <svg width="24" height="24" viewBox="0 0 24 24">
                <path class="a" d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z"/>
              </svg>
              Selecione uma data
            </p>

            <datepicker ref="programaticOpen" v-model="selectedDate" :language="ptBR" :format="customFormatter"/>
            <i v-on:click="removeDateSelected()" v-if="selectedDate" class="fa fa-times remove-date-icon" aria-hidden="true"></i>
          </div>
        </div>

        <div v-if="loadingRequest && firstLoading" v-for="l1 in 12" class="col-xs-12 col-sm-6 col-md-3">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box point-content">
            <a>
              <div class="day-info">
                <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; width: 30%;'"/>
              </div>
              <div class="register-info">
                <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; width: 40%;'"/>
                <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 16px; display: block; width: 40%;'"/>
              </div>
              <div class="status">
                <progress-loading :additionalBoxStyle="''" :additionalLineStyle="'height: 24px; display: block; width: 100%;'"/>
              </div>
            </a>
          </div>
        </div>
        <div v-for="(point, index) in listPoint" class="col-xs-12 col-sm-6 col-md-3">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box point-content point-content-justify">
            <a v-bind:href="'/detalhe-do-ponto/' + point.id + '/' + typeNext">
              <div class="day-info">
                <p class="certa">{{point.convertPointReference | strDay}}, {{point.convertPointReference | formatDate}}</p>
                <span v-if="point.justifyExtra && !point.justify" class="justify-he" v-tooltip.top-center="'Existem horas excedentes à justiticar'">Justificar HE</span>
                <!--                <p class="nunito">{{point.totalPoints}} Registros de ponto</p>-->
              </div>
              <div class="register-info offset-top-40">
                <p class="nunito">Registros de ponto:
                  <span>{{point.totalPoints}}</span>
                </p>
                <p class="nunito">Total Trabalhado:
                  <span v-if="typeNext === 1">{{point.totalWorkedStr}}</span>
                  <span v-if="typeNext === 2">{{point.totalHour}}</span>
                  <img title="Ajuste pendente" v-if="point.userPointAdjustmentStatus === 1" src="../../../..../../../assets/img/icons/build-white.png" class="img-responsive background-bue" alt="build"/>
                  <img title="Ajuste realizado neste dia" v-if="point.userPointAdjustmentStatus === 2" src="../../../..../../../assets/img/icons/build-white.png" class="img-responsive background-green" alt="build"/>
                  <img title="Ajuste reprovado neste dia" v-if="point.userPointAdjustmentStatus === 3" src="../../../..../../../assets/img/icons/build-white.png" class="img-responsive background-red" alt="build"/>
                </p>
              </div>
              <div class="status">
                <p v-bind:class="{
                  'background-default': point.userPointDayStatus <= 1,
                  'background-blue': point.userPointDayStatus === 2,
                  'background-green': point.userPointDayStatus === 3,
                  'background-yellow': point.userPointDayStatus === 4,
                  'background-red': point.userPointDayStatus === 5}" class="nunito background-default">{{point.userPointDayStatusStr}}</p>
              </div>
            </a>
          </div>
        </div>

        <!-- Loading more button -->
        <div v-if="showLoadMore && showDtChange" class="col-xs-12 col-sm-12 col-md-12">
          <button v-if="listPoint.length >= 12" v-on:click="loadMore()" class="nunito btn-show-more">
            <div v-if="loadingRequest" class="loading-btn-login">
              <div class="spinner-btn-yellow">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
            <span v-else>Carregar mais</span>
          </button>
        </div>

        <div v-if="showLoadMore && !showDtChange" class="col-xs-12 col-sm-12 col-md-12">
          <button v-if="listPoint.length >= 12" v-on:click="loadMoreOc()" class="nunito btn-show-more">
            <div v-if="loadingRequest" class="loading-btn-login">
              <div class="spinner-btn-yellow">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
            <span v-else>Carregar mais</span>
          </button>
        </div>

        <!-- Show Msg -->
        <div v-if="!listPoint.length && failRequest && !loadingRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty offset-top-60">
          <img src="../../../..../../../assets/img/empty/internet.png" alt="internet" class="img-fluid img-responsive" />
          <p class="nunito">Tivemos um problema com a conexão, tente novamente atualizando a página.</p>
        </div>

        <!-- Show Msg -->
        <div v-if="!listPoint.length && !failRequest && !loadingRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty offset-top-60">
          <img src="../../../..../../../assets/img/empty/historico.png" alt="historico" class="img-fluid img-responsive" />
          <p v-if="showDtChange" class="nunito">Você não possui nenhum registro de ponto até o momento.</p>
          <p v-else class="nunito">Você ainda possui nenhuma ocorrência nesse momento.</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<!-- Script from page -->
<script>
  import leftMenu from '../../components/leftMenu.vue';
  import progressLoading from "../../components/progressLoading";
  import buttonBack from "../../components/buttonBack";
  import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
  import datepicker from 'vuejs-datepicker';
  import moment from 'moment'
  import swal from 'sweetalert';

  import { POINT_HISTORY, POINT_HISTORY_OC } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import vueFooter from "../../components/footer.vue";

  export default {
    name: 'list-point',
    components: {
      vueFooter,
      leftMenu,
      progressLoading,
      buttonBack,
      datepicker
    },
    data() {
      return {
        lastAtt: null,
        lastForce: 0,
        myOccurrenceCtrl: null,
        pointHistoryCtrl: {},
        pgTitle: '',
        pageOc: 1,
        typeNext: 1,
        ptBR: ptBR,
        isSearch: false,
        firstLoading: false,
        loadingRequest: true,
        showLoadMore: true,
        failRequest: false,
        showDtChange: true,
        listPoint: [],
        initDate: "",
        endDate: "",
        selectedDate: "",
        userInfo: ""
      }
    },
    methods: {
      getPointsOc: function() {
        this.loadingRequest = true;

        let url = POINT_HISTORY_OC;
        url += "p=" + this.pageOc;
        url += "&r=12";

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
            UTIL_SERVICE.console("RESULT POINT_HISTORY_OC:", response.data);

            if (response.data.length) {
              response.data.map((value, index) => {
                value.convertPointReference = this.$options.filters.convertToDayMothYear(value.pointReference);
                this.listPoint.push(value);

                if (response.data.length === index + 1) {
                  this.lastAtt = moment(new Date()).format('DD/MM/YYYY HH:mm');
                  UTIL_SERVICE.saveStorage('myOccurrenceCtrl', {
                    data: this.listPoint,
                    dateAtt: moment(new Date()).format('DD/MM/YYYY HH:mm'),
                    controlBy4Hours: new Date(moment().add(4, 'hours').format()).getTime()
                  });
                }
              });
            } else {
              this.lastAtt = moment(new Date()).format('DD/MM/YYYY HH:mm');
              UTIL_SERVICE.saveStorage('myOccurrenceCtrl', {
                data: null,
                dateAtt: moment(new Date()).format('DD/MM/YYYY HH:mm'),
                controlBy4Hours: new Date(moment().add(4, 'hours').format()).getTime()
              });

              const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
              homeCtrl.advicesNeedReload = true;
              UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl)
            }
            this.loadingRequest = false;
            this.firstLoading = false;
        }).catch(reason => {
          this.failRequest = true;
          this.loadingRequest = false;
          this.firstLoading = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      getPoints: function() {
        this.loadingRequest = true;
        this.failRequest = false;
        this.lastAtt = moment(new Date()).format('DD/MM/YYYY HH:mm');

        moment.locale('pt-br');

        let url = POINT_HISTORY;
        url += "?c=" + this.userInfo.companyId;
        url += "&u=" + this.userInfo.id;
        url += "&initDate=" + this.initDate;
        url += "&endDate=" + this.endDate;
        url += "&r=12";

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT POINT_HISTORY:", response.data);

          // Check data exist to map
          if (response.data.length) {
            response.data.map((value, index) => {
              value.convertPointReference = this.$options.filters.convertToDayMothYear(value.pointReference);
              this.listPoint.push(value);

              if (index + 1 === response.data.length) {
                if (!this.isSearch) {
                  UTIL_SERVICE.saveStorage('pointHistoryCtrl', {
                    getRequest: false,
                    initDate: this.initDate,
                    endDate: this.endDate,
                    listHistory: this.listPoint,
                    dateAtt: moment(new Date()).format('DD/MM/YYYY HH:mm'),
                    controlBy4Hours: new Date(moment().add(4, 'hours').format()).getTime()
                  });
                }

                this.loadingRequest = false;
                this.firstLoading = false;
              }
            });
          } else {
            this.loadingRequest = false;
            this.showLoadMore = false;
            this.firstLoading = false;
          }

        }).catch(reason => {
          this.failRequest = true;
          this.loadingRequest = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      loadMoreOc: function() {
        this.pageOc++;

        this.getPointsOc();
      },
      loadMore: function () {
        this.endDate = moment(this.initDate).subtract(1, 'days').format("YYYY-MM-DD");
        this.initDate = moment(this.initDate).subtract(16, 'days').format("YYYY-MM-DD");

        this.getPoints();
      },
      searchFromDate: function () {
        this.initDate = moment(this.selectedDate).format("YYYY-MM-DD");
        this.endDate =  moment(this.selectedDate).format("YYYY-MM-DD");

        this.listPoint = [];
        this.showLoadMore = false;

        this.getPoints();
      },
      openCalendar: function () {
        this.$refs.programaticOpen.showCalendar();
      },
      removeDateSelected: function () {
        this.selectedDate = "";
        this.initDate = moment().subtract(15, 'days').format("YYYY-MM-DD");
        this.endDate = moment().format("YYYY-MM-DD");
        this.listPoint = [];
        this.firstLoading = true;
        this.isSearch = false;

        this.getPoints();
      },
      customFormatter(date) {
        return moment(date).format('DD/MM/YYYY');
      },
      forceReload() {
        let dataNow = new Date().getTime();
        if (dataNow > this.lastForce) {
          this.lastForce = dataNow + 60000;

          if (window.location.pathname.includes("historico-de-ocorrencia")) {
            this.firstLoading = true;
            this.showDtChange = false;

            this.getPointsOc();
          } else {
            this.firstLoading = true;

            this.getPoints();
          }
        }
      }
    },
    beforeMount() {
      this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
      let dataNow = new Date().getTime();

      this.initDate = moment().subtract(15, 'days').format("YYYY-MM-DD");
      this.endDate = moment().format("YYYY-MM-DD");

      if (window.location.pathname.includes("historico-de-ocorrencia")) {
        this.pgTitle = "Histórico de ocorrências";
        this.firstLoading = true;
        this.showDtChange = false;
        this.typeNext = 2;

        this.getPointsOc();
        // try {
        //   this.myOccurrenceCtrl = UTIL_SERVICE.getStorage('myOccurrenceCtrl');
        //
        //   // Att notices before 4 hours
        //   if (dataNow > this.myOccurrenceCtrl.controlBy4Hours) {
        //     this.getPointsOc();
        //   } else {
        //     UTIL_SERVICE.console('GET DATA FROM STORAGE', this.myOccurrenceCtrl);
        //
        //     if (this.myOccurrenceCtrl.data) {
        //       this.lastAtt = this.myOccurrenceCtrl.dateAtt;
        //       this.listPoint = this.myOccurrenceCtrl.data;
        //       this.loadingRequest = false;
        //       this.firstLoading = false;
        //     } else {
        //       this.getPointsOc();
        //     }
        //   }
        // } catch (e) {
        //   UTIL_SERVICE.saveStorage('myOccurrenceCtrl', {
        //     data: null,
        //     dateAtt: null,
        //     controlBy4Hours: null
        //   });
        //
        //   this.getPointsOc();
        // }
      } else {
        this.firstLoading = true;
        this.pgTitle = "Histórico de ponto";
        this.typeNext = 1;

        this.getPoints();
        // try {
        //   this.pointHistoryCtrl =  UTIL_SERVICE.getStorage('pointHistoryCtrl');
        //
        //   if (this.pointHistoryCtrl.getRequest) {
        //     this.getPoints();
        //   } else {
        //     // Att notices before 4 hours
        //     if (dataNow > this.pointHistoryCtrl.controlBy4Hours) {
        //       this.getPoints();
        //     } else {
        //       UTIL_SERVICE.console('GET DATA FROM STORAGE', this.pointHistoryCtrl);
        //
        //       if (this.pointHistoryCtrl.listHistory) {
        //         this.lastAtt = this.pointHistoryCtrl.dateAtt;
        //         this.endDate = this.pointHistoryCtrl.initDate;
        //         this.initDate = this.pointHistoryCtrl.initDate;
        //         this.listPoint = this.pointHistoryCtrl.listHistory;
        //
        //         this.loadingRequest = false;
        //         this.firstLoading = false;
        //       } else {
        //         this.getPoints();
        //       }
        //     }
        //   }
        // } catch (e) {
        //   UTIL_SERVICE.saveStorage('pointHistoryCtrl',{
        //     getRequest: true,
        //     controlBy4Hours: null,
        //     dateAtt: null,
        //     initDate: null,
        //     endDate: null,
        //     listHistory: []
        //   });
        //
        //   this.getPoints();
        // }
      }
    },
    filters: {
      convertToDayMothYear: (value) => {
        if (value) {
          let year = value.toString().substring(0, 4);
          let month = value.toString().substring(4, 6);
          let day = value.toString().substring(6, 8);

          return year + "-" + month + "-" + day;
        } else {
          return "";
        }
      }
    },
    watch: {
      selectedDate: function (val) {
        if (this.selectedDate) {
          this.firstLoading = true;
          this.isSearch = true;

          this.searchFromDate();
        }
      }
    }
  }
</script>

<style lang="scss">

.point-content-justify {
  .day-info {
    display: flex;
    justify-content: space-between;

    p {
      font-size: 16px;
    }
  }

  @media screen and (max-width: 1242px) and (min-width: 1200px) {
    min-height: 225px !important;
  }
}

.justify-he {
  background: var(--yellowWithText);
  color: #FFFFFF;
  border-radius: 4px;
  padding: 3px 9px;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.txt-info {
  position: absolute;
  top: 8px;
  left: 230px;

  @media only screen and (max-width: 460px) {
    position: absolute;
    top: -25px;
    left: 16px;
  }
}

.date-change-history {
  width: 200px !important;

  .remove-date-icon {
    color: var(--textSide) !important;
  }
}

.date-history-point {
  top: -1px;
}

</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/pointHistory/PointHistory.vue